import { A9Service, AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { cardParamsValidType, CustomerCardParamsUpdate, RsCustomerCardParamsInfo } from 'common/customers/services';
import { SystemDate } from 'components/system/services';

export function cardParamsInfoToUpdate(data: RsCustomerCardParamsInfo): CustomerCardParamsUpdate {
    return {
        validDate: data.validDate,
        validDays: data.validDays,
        validMonths: data.validMonths,
        validType: data.validType,
        validYears: data.validYears
    };
}

export interface ICustomerCardsParamsDataProvider extends IDataProviderV2<{}, RsCustomerCardParamsInfo, {}, CustomerCardParamsUpdate> {
    getDefault(): Promise<IDefaultCustomerCardParams>;
}

export interface IDefaultCustomerCardParams extends RsCustomerCardParamsInfo {
    validFrom: string;
    validTo: string;
}

@A9Service('customerCardsParamsDataProvider')
class CustomerCardsParamsDataProvider
    extends AbstractDataProviderV2<{}, RsCustomerCardParamsInfo, {}, CustomerCardParamsUpdate>
    implements ICustomerCardsParamsDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/cards/params');
    }

    patch(): Promise<null> {
        return Promise.reject('Method is not supported');
    }

    list(): Promise<null> {
        return Promise.reject('Method is not supported');
    }

    remove(): Promise<null> {
        return Promise.reject('Method is not supported');
    }

    add(): Promise<null> {
        return Promise.reject('Method is not supported');
    }

    getDefault(): Promise<IDefaultCustomerCardParams> {
        return this.get().then(params => {
            const result: IDefaultCustomerCardParams = { ...params, validFrom: '', validTo: '' };
            result.validFrom = SystemDate.getInstance().getMoment().format('YYYY-MM-DD');

            if (params.validType === cardParamsValidType.EndDate) {
                result.validTo = params.validDate;
            } else {
                result.validTo = SystemDate.getInstance()
                    .getMoment()
                    .add(params.validYears, 'years')
                    .add(params.validMonths, 'months')
                    .add(params.validDays, 'days')
                    .format('YYYY-MM-DD');
            }
            return result;
        });
    }
}
